import { render, staticRenderFns } from "./TableBubbleMenu.vue?vue&type=template&id=08d7a544&scoped=true"
import script from "./TableBubbleMenu.vue?vue&type=script&lang=js"
export * from "./TableBubbleMenu.vue?vue&type=script&lang=js"
import style0 from "./TableBubbleMenu.vue?vue&type=style&index=0&id=08d7a544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d7a544",
  null
  
)

export default component.exports